import { render, staticRenderFns } from "./PublishingContractsCostsEditPanel.vue?vue&type=template&id=1afe0460"
import script from "./PublishingContractsCostsEditPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsCostsEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports